import { Injectable } from '@angular/core';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';

const EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
@Injectable({
  providedIn: 'root',
})
export class ExcelService {
  constructor() {

    
  }

  public exportAsExcelFile(json: any[], excelFileName: string): void {
    const worksheet: XLSX.WorkSheet = XLSX.utils.json_to_sheet(json);
    const workbook: XLSX.WorkBook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
    const excelBuffer: any = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
    this.saveAsExcelFile(excelBuffer, excelFileName);
  }
  private saveAsExcelFile(buffer: any, fileName: string): void {
     const data: Blob = new Blob([buffer], {type: EXCEL_TYPE});
     FileSaver.saveAs(data, fileName + '_export_' + new  Date().getTime() + EXCEL_EXTENSION);
  }


  // generateExcel()
  // {

  //     // 1
  //   //Excel Title, Header, Data
  //   const title = 'Car Sell Report';
  //   const header = ["Year", "Month", "Make", "Model", "Quantity", "Pct"]
  //   const data = [
  //     [2007, 1, "Volkswagen ", "Volkswagen Passat", 1267, 10],
  //     [2007, 1, "Toyota ", "Toyota Rav4", 819, 6.5],
  //     [2007, 1, "Toyota ", "Toyota Avensis", 787, 6.2],
  //     [2007, 1, "Volkswagen ", "Volkswagen Golf", 720, 5.7],
  //     [2007, 1, "Toyota ", "Toyota Corolla", 691, 5.4],
  //     [2007, 1, "Peugeot ", "Peugeot 307", 481, 3.8],
  //     [2008, 1, "Toyota ", "Toyota Prius", 217, 2.2],
  //     [2008, 1, "Skoda ", "Skoda Octavia", 216, 2.2],
  //     [2008, 1, "Peugeot ", "Peugeot 308", 135, 1.4],
  //     [2008, 2, "Ford ", "Ford Mondeo", 624, 5.9],
  //     [2008, 2, "Volkswagen ", "Volkswagen Passat", 551, 5.2],
  //     [2008, 2, "Volkswagen ", "Volkswagen Golf", 488, 4.6],

  //   ];


  //   // 2
  //  //Create workbook and worksheet
  //  let workbook = new Workbook();
  //  let worksheet = workbook.addWorksheet('Car Data');


  // //  3
  //  //Add Row and formatting
  //  let titleRow = worksheet.addRow([title]);
  //  titleRow.font = { name: 'Comic Sans MS', family: 4, size: 16, underline: 'double', bold: true }
  //  worksheet.addRow([]);
  //  let subTitleRow = worksheet.addRow(['Date : ' + this.datePipe.transform(new Date(), 'medium')])


  // //  4
  // //Add Image
  // // let logo = workbook.addImage({
  // //   base64: logoFile.logoBase64,
  // //   extension: 'png',
  // // });

  // // 5
  // worksheet.mergeCells('A1:D2');
  // worksheet.addRow([]);


  //  //Add Header Row
  //  let headerRow = worksheet.addRow(header);
    
  //  // Cell Style : Fill and Border
  //  headerRow.eachCell((cell, number) => {
  //    cell.fill = {
  //      type: 'pattern',
  //      pattern: 'solid',
  //      fgColor: { argb: 'FFFFFF00' },
  //      bgColor: { argb: 'FF0000FF' }
  //    }
  //    cell.border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
  //  })

  //  // Add Data and Conditional Formatting
  //  data.forEach(d => {
  //   let row = worksheet.addRow(d);
  //   let qty = row.getCell(5);
  //   let color = 'FF99FF99';
  //   if (+qty.value < 500) {
  //     color = 'FF9999'
  //   }

  //   qty.fill = {
  //     type: 'pattern',
  //     pattern: 'solid',
  //     fgColor: { argb: color }
  //   }
  // }

  // );

  // worksheet.getColumn(3).width = 30;
  // worksheet.getColumn(4).width = 30;
  // worksheet.addRow([]);

  //  //Footer Row
  //  let footerRow = worksheet.addRow(['This is system generated excel sheet.']);
  //  footerRow.getCell(1).fill = {
  //    type: 'pattern',
  //    pattern: 'solid',
  //    fgColor: { argb: 'FFCCFFE5' }
  //  };
  //  footerRow.getCell(1).border = { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }

  //  //Merge Cells
  //  worksheet.mergeCells(`A${footerRow.number}:F${footerRow.number}`);

  //  //Generate Excel File with given name
  //  workbook.xlsx.writeBuffer().then((data) => {
  //    let blob = new Blob([data], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
  //    fs.saveAs(blob, 'CarData.xlsx');
  //  })


  // }
}
